import React from 'react'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import {getDefaultValue, isMobile} from 'utils/utils'
import environment from 'utils/enums/environment'

const Input = styled.input`
    width: 100%;
    height: 100%;
    padding: 0 10px;
    box-sizing: border-box;

    + div {
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        position: absolute;
        transform: scaleX(0);
        transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
        border-bottom: 2px solid #415dd4;
        pointer-events: none;
    }

    :focus {
        ~ div {
            display: none;
        }

        + div {
            transform: scaleX(1);
            display: block;
        }
    }
`

class Numeric extends React.PureComponent {
    constructor(props) {
        super(props)

		this.mobile = isMobile()

        this.state = {
            value: props.defaultValue
        }
    }

	componentDidUpdate(props) {
        if (props.defaultValue !== this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue })
        }
    }

	handleChange = (value) => {
        if (this.state.value !== value.floatValue) {
            this.setState({
                value: value.floatValue || value.floatValue === 0 ? value.floatValue : null
            }, () => !this.props.environment ? this.props.handleUpdate(this.state.value, this.props.name) : {})
        }
    }

    handleBlur = () => {
        if (this.props.environment && this.state.value !== this.props.defaultValue) {
            this.props.handleUpdate(this.state.value, this.props.name)
        }
    }

    handleFocus = () => {
        if (this.props.environment && !this.props.defaultValue && this.props.defaultValue !== 0) {
            const value = getDefaultValue(this.props.environment, this.props.name, this.props.row)
            if (value !== null && value !== undefined) {
                this.setState({ value }, () => setTimeout(() => {
                    this.number.select()
                }, 5))
            }
        }
    }

    render() {
		const {config, lookup, readonly} = this.props
		const disabled = (this.mobile && this.props.environment === environment.Collection) || readonly

        return (
			<React.Fragment>
				<NumberFormat
					getInputRef={el => this.number = el}
					customInput={Input}
					style={lookup ? { opacity: 0.5 } : {}}
					value={config && config.decimalLength === 0 ? parseInt(this.state.value) : this.state.value}
					thousandSeparator=' '
					suffix={config && config.currencyPosition === 2 && config.currencySymbol ? ' ' + config.currencySymbol : ''}
					prefix={config && config.currencyPosition === 1 && config.currencySymbol ? config.currencySymbol + ' ' : ''}
					decimalSeparator={config ? config.decimalSeparator : ','}
					decimalScale={config ? Number(config.decimalLength) : 0}
					fixedDecimalScale={true}
					disabled={readonly}
					onValueChange={this.handleChange}
					onBlur={this.handleBlur}
					onFocus={this.handleFocus}
				/>
				{!disabled && <div />}
			</React.Fragment>
        )
    }
}

export default Numeric
